type Page<TItem> = {
  items: TItem[];
  nextToken?: string | null;
};

export const fetchAllPages = async <TItem>(
  fetchPage: (nextToken?: string) => Promise<Page<TItem>>,
  nextToken?: string
): Promise<TItem[]> => {
  const page = await fetchPage(nextToken);
  if (!page.nextToken) return page.items;

  return [...page.items, ...(await fetchAllPages(fetchPage, page.nextToken))];
};
